import api from "dao/providers/axios";
import appconfig from "config/appconfig";

const oAuthScpesEndPoint =  appconfig.endpoints.oAuthScopes;

export const daoOauthScopesGet = () => api.get(oAuthScpesEndPoint);